export default "__VITE_ASSET__5cGquK7$__"